import React from 'react';

import './WelcomePage.css';

const WelcomePage = () => {

    return (
        <div className='welcome-page'>
            <h1>Welcome to<br /> Lost &amp; Found!</h1>
            <p>Press the button to answer a few questions about what you've lost.</p>
        </div>
    );
};

export default WelcomePage;